const hasOwnProperty = Object.prototype.hasOwnProperty, has = (object, key) => null != object && hasOwnProperty.call(object, key);

export default has;
//# sourceMappingURL=has.js.map